import { useState, useEffect } from 'react';
import debounce from 'lodash.debounce';
import { canUseDOM } from '../helpers/index.es.js';

function useWindowSize() {
  function getSize() {
    if (typeof window !== "undefined")
      return {
        width: window.innerWidth,
        height: window.innerHeight
      };
  }
  const [windowSize, setWindowSize] = useState(getSize);
  const updateWindowSize = debounce(setWindowSize, 1e3);
  useEffect(() => {
    if (!canUseDOM) {
      return;
    }
    function handleResize() {
      updateWindowSize(getSize());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  if (!canUseDOM) {
    return void 0;
  }
  return windowSize;
}

export { useWindowSize };
